import {h, Fragment} from "preact"
export default function () {
    return (
        <div
            class="ns-loader-wrapper ns-d-flex ns-justify-content-center ns-align-items-center"
            style="position: relative; z-index: 1;"
        >
            <div class="ns-loader"></div>
        </div>
    )
}
